import React from 'react';
import { buildImagePath } from '../../../../JobComponents/Company/Image/logo';
import CommonCardShell from '../../../../Layout/CommonCardShell/CommonCardShell';

import './MasterFeedTitleCard.scss';

export default class MasterFeedTitleCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {};

    static defaultProps = {};

    render() {
        const injectedTransform = {
            default: '',
        };
        return (
            <div className="component-Content-Feed-Components-MasterFeedTitleCard">
                <CommonCardShell className="master-feed-title-card-shell">
                    <img
                        className="girl-one"
                        src={buildImagePath(
                            '/v1556216845/SVGs/girl1.svg',
                            'default',
                            injectedTransform
                        )}
                        alt={'girl-one-image'}
                    />
                    <div className="title-card-title">
                        The Fairygodboss Feed
                    </div>
                    <div className="title-card-description">
                        We're a community of women sharing advice and asking
                        questions
                    </div>
                    <img
                        className="background-svg"
                        src={buildImagePath(
                            '/v1556216845/SVGs/background.svg',
                            'default',
                            injectedTransform
                        )}
                        alt={'background-svg'}
                    />
                    <img
                        className="girl-two"
                        src={buildImagePath(
                            '/v1556216845/SVGs/girl2.svg',
                            'xSmall'
                        )}
                        alt={'girl-two-image'}
                    />
                </CommonCardShell>
            </div>
        );
    }
}
